import {useLocation, useNavigate, useResolvedPath} from "react-router-dom";

import {CUSTOM_FONT_FAMILY} from "Theme";

import MenuItem from "@mui/material/MenuItem";
import useTheme from "@mui/material/styles/useTheme";

const AppMenuItem = ({
    to,
    icon = null,
    text = "",
    textStyle = {},
    tooltipTitle = "",
    resolvedPathName = null,
    ...props
}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    let resolved = useResolvedPath(resolvedPathName || to);
    let location = useLocation();

    let selected = location.pathname.startsWith(resolved.pathname);

    const defaultItemStyle = {
        color: "white",
        fontFamily: CUSTOM_FONT_FAMILY,
        ...textStyle,
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    };

    const selectedItemtStyle = {
        ...defaultItemStyle,
        "&.Mui-selected": {
            backgroundColor: theme.palette.primary.light,
            color: "white",
            "&:hover": {
                backgroundColor: theme.palette.primary.light,
            },
        },
    };

    return (
        <MenuItem
            role="tab"
            tabIndex={0}
            aria-selected="true"
            onClick={() => {
                navigate(`/${to}`);
            }}
            selected={selected}
            sx={selected ? selectedItemtStyle : defaultItemStyle}
        >
            {text}
        </MenuItem>
    );
};

export default AppMenuItem;
